import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const btn = "pagination-button";
  const btnActive = "pagination-button-active";

  // Below `sm`, only a 3-number window (same clamping math as the 5-number one)
  // is shown, so the row fits a phone screen without wrapping.
  const mobileWindowStart = Math.max(1, Math.min(totalPages - 2, currentPage - 1));

  return (
    <div className="flex flex-wrap justify-center items-center gap-1">
      <button onClick={() => onPageChange(1)} disabled={currentPage === 1} className={`${btn} hidden sm:inline-flex`} aria-label="First page">First</button>
      <button onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className={btn} aria-label="Previous page">
        <span className="hidden sm:inline">Previous</span>
        <ChevronLeft className="w-4 h-4 sm:hidden" aria-hidden="true" />
      </button>

      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        const page = Math.max(1, Math.min(totalPages - 4, currentPage - 2)) + i;
        const hiddenOnMobile = page < mobileWindowStart || page > mobileWindowStart + 2;
        return (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`${currentPage === page ? btnActive : btn}${hiddenOnMobile ? ' hidden sm:inline-flex' : ''}`}
            aria-label={`Page ${page}`}
            aria-current={currentPage === page ? 'page' : undefined}
          >
            {page}
          </button>
        );
      })}

      <button onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} className={btn} aria-label="Next page">
        <span className="hidden sm:inline">Next</span>
        <ChevronRight className="w-4 h-4 sm:hidden" aria-hidden="true" />
      </button>
      <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} className={`${btn} hidden sm:inline-flex`} aria-label="Last page">Last</button>
    </div>
  );
};

export default Pagination;
